/***
 *
 *   SUB NAV
 *   Sub navigation element (located underneath the header).
 *
 **********/

import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from 'components/lib';
import type { PermissionFlags } from 'app/authContext';
import './sub.scss';

interface SubNavItem {
  label: string;
  link: string;
  permission?: string;
  disabled?: boolean;
}

interface SubNavProps {
  items?: SubNavItem[];
}

export function SubNav(props: SubNavProps) {
  const context = useContext(AuthContext);

  return (
    <nav className="subnav">
      {props.items?.map((item) => {
        if (item.permission && !context.permission?.[item.permission as keyof PermissionFlags]) return false;

        if (item.disabled)
          return (
            <span key={item.label} className="item disabled" aria-disabled="true">
              {item.label}
            </span>
          );

        return (
          <NavLink key={item.label} to={item.link} className={({ isActive }) => `item${isActive ? ' active' : ''}`}>
            {item.label}
          </NavLink>
        );
      })}
    </nav>
  );
}
